import { Button, Flex, Heading, Image } from '@chakra-ui/core';
import { ChevronRightIcon } from '@chakra-ui/icons';
import React from 'react';
import WalletImage from '../../assets/wallet.svg';
import InfoCheckStack from '../../components/InfoCheckStack';

const INFO_STRINGS = [
  <>
    Use this <b>non-custodial</b> wallet to deposit funds to bet
  </>,
  'You remain in full control of funds you deposit at all times. ',
  "We can't touch your funds",
];

const WalletInfo = ({ onBack, onNext }) => {
  return (
    <>
      <Flex flexDir="column" alignItems="center">
        <Heading size="sm" as="h4" textAlign="center" mb={8}>
          You will be setting up a Atomic Odds Wallet
        </Heading>
        <Image src={WalletImage} h="150px" mb={8} />

        <InfoCheckStack infoStrings={INFO_STRINGS} />
      </Flex>
      <Flex flexDir="row" mt={4}>
        <Button onClick={onBack}>Go Back</Button>
        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={onNext}
        >
          Setup Wallet
        </Button>
      </Flex>
    </>
  );
};

export default WalletInfo;
